export default __webpack_public_path__ + "assets/hotgiggity.dca21ff6.svg";